import { currentLang } from "@hiptraveler/common";
import { Metadata } from "..";

export function interceptMetadataValue(value: Metadata): Metadata {

  if (value.url.includes(`/${currentLang()}/ambassador`)) {
    value.imageUrl = 'https://d36j46pvk6qi4f.cloudfront.net/site/main/images/Destination-Specialist-1200.webp';
  }
  
  if (value.url.includes(`/${currentLang()}/travel-agent-register`)) {
    value.imageUrl = 'https://d36j46pvk6qi4f.cloudfront.net/site/main/images/Destination-Specialist-1200.webp';
  }

  return value;
}
